import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { CustomEquipmentOptionsView } from "./custom/CustomEquipmentOptionsView"

export const getCustomEquipmentOptionsRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, CustomEquipmentOptionsView> =
	{
		buildUrl: () => "/equipment/custom/options",
		method: "get",
		path: "/equipment/custom/options",
	}
